import { render, staticRenderFns } from "./ResolveAction.vue?vue&type=template&id=450a7386&scoped=true&"
import script from "./ResolveAction.vue?vue&type=script&lang=js&"
export * from "./ResolveAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveAction.vue?vue&type=style&index=0&id=450a7386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a7386",
  null
  
)

export default component.exports